import { Component, Inject, Input, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HistoryData, TableColumn } from '@app/shared/models/common.model';

@Component({
    selector: 'app-history-dialog',
    templateUrl: './history-dialog.component.html',
    standalone: false
})
export class HistoryDialogComponent {
  @Input() historyColumns!: Map<string, TableColumn>;
  @Input() title: string = 'App.StatusHistory.Labels.StatusHistory';
  @Input() showRefundColumn: boolean = false;
  @Output() onRefund: EventEmitter<any> = new EventEmitter<any>();

  public historyDataSource: any;
  public isRefunding: boolean = false;
  public refundingChargeId: string | null = null;

  constructor(
    private dialogRef: MatDialogRef<HistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HistoryData
  ) {
    this.historyDataSource = { results: data.history, resultCount: data.history.length };
    this.dialogRef.addPanelClass(['dialog', 'fit-content-dialog']);
    this.dialogRef.updateSize('600px', 'auto');
  }

  closeDialog() {
    this.dialogRef.close();
  }

  handleRefund(row: any): void {
    this.onRefund.emit(row);
  }

  getColumnsWithRefund(): string[] {
    const cols = Array.from(this.historyColumns.keys());
    cols.push('refund');
    return cols;
  }
}